// assets
import { DashboardOutlined, UserOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  UserOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const menuItems = {
  id: 'dashboard',
  title: 'Tổng quan',
  type: 'group',
  children: [
    {
      id: 'dashboard-default',
      title: 'Dashboard',
      type: 'item',
      url: '/',
      icon: icons.DashboardOutlined,
      target: false,
      visible: true
    },
    {
      id: 'profile',
      title: 'Trang cá nhân',
      type: 'item',
      url: '/profile',
      icon: icons.UserOutlined,
      target: false,
      visible: true
    }
  ]
};

export default menuItems;
